import { useStaticQuery, graphql } from "gatsby"

const useNavigation = () => {
  const { storyblokEntry } = useStaticQuery(graphql`
    query NavigationQuery {
      storyblokEntry(full_slug: { eq: "navigation/" }) {
        content
      }
    }
  `)

  return storyblokEntry
}

export { useNavigation }
